(ns portal.adserver-configuration-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.queries :refer [use-query]]
            [common.resource.query.adserver-account-configuration :as adserver-config.q]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- format-name
  [{:keys [row value]}]
  ($ Stack {:direction "row" :alignItems "center" :spacing 1}
     ($ Typography value)
     (when (:isDefault row)
       ($ Chip {:label "Default"}))))

(defn- format-autotagging
  [value]
  (if (some? value)
    (str/capitalize (str value))
    "Unavailable"))

(def ^:private columns
  #js [#js {:field "name"
            :headerName "Name"
            :type "string"
            :minWidth 200
            :flex 1
            :sortable true
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (get-in row [:adserveraccount :name]))
            :renderCell (uix/as-react format-name)}
       #js {:field "apiAdvertiserId"
            :headerName "API ID"
            :type "string"
            :minWidth 150
            :flex 1
            :sortable false
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:apiAdvertiserId row))}
       #js {:field "hasAutoTagging"
            :headerName "Autotagging"
            :type "string"
            :minWidth 150
            :flex 1
            :sortable false
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:hasAutoTagging row))
            :valueFormatter (fn [^js value]
                              (format-autotagging value))}])

(def no-rows-overlay
  (uix/as-react
   (fn [{:keys [is-error is-empty]}]
     ($ Stack
        {:alignItems "center"
         :justifyContent "center"
         :height "100%"}
        ($ Typography
           (cond
             is-error "Could not load Adserver Configurations"
             is-empty "No Adserver Configurations have been created for this advertiser yet"
             :else "No results"))))))

(defn- get-row-id [row]
  (:id row))

(def toolbar
  (uix/as-react
   (fn []
     ($ dg/grid-toolbar
        ($ Button
           {:variant "contained"
            :on-click #(rf/dispatch [:ocp/open
                                     {:id :adserver-configuration/crud}])
            :data-testid "AddConfigurationButton"}
           "Add Configuration")))))

(defui table []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [data isPending isError]} (use-query (adserver-config.q/adserver-account-configurations-query
                                                     {:advertiser-id advertiser-id}))

        page-size 10

        initial-state (uix/use-memo
                       (fn []
                         #js {:pagination #js {:paginationModel #js {:pageSize page-size}}})
                       [page-size])

        on-row-click (uix/use-callback
                      (fn [^js params]
                        (let [adserver-configuration (->clj (.-row params))]
                          (rf/dispatch [:ocp/open {:id :adserver-configuration/crud
                                                   :props {:adserver-configuration adserver-configuration}}])))
                      [])]
    ($ DataGridPremium
       {:columns columns
        :loading isPending

        :rows (to-array (or data []))
        :getRowId get-row-id

        :onRowClick on-row-click

        :pagination true
        :pageSizeOptions #js [page-size]

        :initialState initial-state

        :slots #js {:toolbar toolbar
                    :noRowsOverlay no-rows-overlay}
        :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                        :noRowsOverlay #js {:is-error isError
                                            :is-empty (empty? data)}}

        :data-testid "adserverConfigurationTable"

        :sx #js {"& .MuiDataGrid-row:hover" #js {:cursor "pointer"}
                 :maxHeight "70rem"}})))
